import React, { useState, useEffect } from "react";
import { TempleWallet } from "@temple-wallet/dapp";
const Wallet = () => {
  const [wallet, setWallet] = useState(null);
  // 🔹 Function to Connect Wallet
  const connectWallet = async () => {
    try {
      console.log("Checking if Temple Wallet is available...");
      if (!TempleWallet.isAvailable()) {
        alert("Temple Wallet not available. Please install it.");
        return;
      }

      console.log("Temple Wallet found. Connecting...");
      const wallet = new TempleWallet("MyNFTApp");
      await wallet.connect("ghostnet"); // Use "ghostnet" for testing or "mainnet"

      console.log("Fetching wallet address...");
      const userAddress = await wallet.getPKH();

      setWallet({ instance: wallet, pkh: userAddress });

      // ✅ Save wallet address to localStorage
      localStorage.setItem("walletAddress", userAddress);

      alert(`Wallet connected: ${userAddress}`);
      console.log("Wallet connected successfully:", userAddress);
    } catch (error) {
      console.error("Temple Wallet Connection Error:", error);
      alert(`Failed to connect Temple Wallet: ${error.message}`);
    }
  };

  // 🔹 Function to Restore Wallet Connection After Refresh
  useEffect(() => {
    const restoreWallet = async () => {
      const savedAddress = localStorage.getItem("walletAddress");
      if (savedAddress) {
        setWallet({ pkh: savedAddress }); // Restore wallet address
      }
    };

    restoreWallet();
  }, []);
  return (
    <div className="row">
      <div className="col-lg-4 mb30"></div>
      <div className="col-lg-4 mb30">
        {/* Connect Wallet Button */}
        {!wallet ? (
          <span className="box-url left p-3">
            <span className="box-url-label">Most Popular</span>
            <img src="./img/wallet/templewallet.png" alt="" className="mb20" />
            <h4>Temple Wallet</h4>
            <p>
              A user-friendly wallet for interacting with the Tezos blockchain.
              Secure, versatile, and trusted by the Tezos community worldwide.
            </p>
            <button
              className="btn-main"
              variant="contained"
              onClick={connectWallet}
            >
              Connect Temple Wallet
            </button>
            {/* Connect Wallet Button */}
          </span>
        ) : (
          <span className="box-url left p-3">
            <span className="box-url-label">Most Popular</span>
            <img src="./img/wallet/templewallet.png" alt="" className="mb20" />
            <h4>Temple Wallet</h4>
            <p className="m-0">
              A user-friendly wallet for interacting with the Tezos blockchain.
              Secure, versatile, and trusted by the Tezos community worldwide.
            </p>
            <div className="walletconnect">
              <p className="mt-1">Connected: </p>
              <span>{wallet.pkh}</span>
            </div>
          </span>
        )}
      </div>
      <div className="col-lg-4 mb30"></div>
      {/* <div className="col-lg-3 mb30">
        <span className="box-url left p-3">
          <span className="box-url-label">Most Popular</span>
          <img src="./img/wallet/1.png" alt="" className="mb20" />
          <h4>Metamask</h4>
          <p>
            Start exploring blockchain applications in seconds. Trusted by over
            1 million users worldwide.
          </p>
        </span>
      </div>

      <div className="col-lg-3 mb30">
        <span className="box-url left p-3">
          <img src="./img/wallet/2.png" alt="" className="mb20" />
          <h4>Bitski</h4>
          <p>
            Bitski connects communities, creators and brands through unique,
            ownable digital content.
          </p>
        </span>
      </div>

      <div className="col-lg-3 mb30">
        <span className="box-url left p-3">
          <img src="./img/wallet/3.png" alt="" className="mb20" />
          <h4>Fortmatic</h4>
          <p>
            Let users access your Ethereum app from anywhere. No more browser
            extensions.
          </p>
        </span>
      </div>

      <div className="col-lg-3 mb30">
        <span className="box-url left p-3">
          <img src="./img/wallet/4.png" alt="" className="mb20" />
          <h4>WalletConnect</h4>
          <p>
            Open source protocol for connecting decentralised applications to
            mobile wallets.
          </p>
        </span>
      </div>

      <div className="col-lg-3 mb30">
        <span className="box-url left p-3">
          <img src="./img/wallet/5.png" alt="" className="mb20" />
          <h4>Coinbase Wallet</h4>
          <p>
            The easiest and most secure crypto wallet. ... No Coinbase account
            required.
          </p>
        </span>
      </div>

      <div className="col-lg-3 mb30">
        <span className="box-url left p-3">
          <img src="./img/wallet/6.png" alt="" className="mb20" />
          <h4>Arkane</h4>
          <p>
            Make it easy to create blockchain applications with secure wallets
            solutions.
          </p>
        </span>
      </div>

      <div className="col-lg-3 mb30">
        <span className="box-url left p-3">
          <img src="./img/wallet/7.png" alt="" className="mb20" />
          <h4>Authereum</h4>
          <p>
            Your wallet where you want it. Log into your favorite dapps with
            Authereum.
          </p>
        </span>
      </div>

      <div className="col-lg-3 mb30">
        <span className="box-url left p-3">
          <span className="box-url-label">Most Simple</span>
          <img src="./img/wallet/8.png" alt="" className="mb20" />
          <h4>Torus</h4>
          <p>
            Open source protocol for connecting decentralised applications to
            mobile wallets.
          </p>
        </span>
      </div> */}
    </div>
  );
};
export default Wallet;
